<template>
  <div class="index-container">
    <keep-alive>
      <div>
        <Header :showInfo="showinfo" :showBack="true"/>
      </div>
    </keep-alive>
    <div class="send-warp">
      <div class="user-info-box">
        <img :src="userInfo.headImage" alt="">
        <p class="tab-title">{{userInfo.nickname}}</p>
      </div>
      <div class="input-box">
        <input type="text" v-model="title" maxlength="40" placeholder="输入标题">
        <span :class="{'red-color': title.length > 39}">{{title.length}}/40</span>
      </div>
      <div class="content-box">
        <textarea v-model="content" placeholder="发表您的观点…"></textarea>
      </div>
    </div>
    <div class="send-footer">
      <p>声明：用户发表的所有言论等仅代表个人观点，与本网站立场无关，不对您构成任何投资建议。</p>
      <div class="send-btn" :class="{disable: !title || !content}" @click="sendView">发布新帖<i class="icon-send"></i></div>
    </div>
    <Toast v-if="showToast" :text="toastText"></Toast>
  </div>
</template>

<script type="text/ecmascript-6">
import { request } from '@/api/request'
import { mapState } from 'vuex'
import Header from '../../home/Header/index.vue'
import Toast from '@/components/toast.vue'
export default {
  components: { Header, Toast },
  data () {
    return {
      showinfo: false,
      title: '',
      content: '',
      toastText: '帖子已提交，将在审核完毕后发布',
      showToast: false
    }
  },
  computed: {
    ...mapState(['userInfo', 'symbol', 'market', 'tabIndex', 'tabs', 'code']),
    ...mapState({
      tabs: state => state.common.tabs,
      tabIndex: state => state.common.tabIndex,
    })
  },
  created () {
    this.createInit()
  },
  methods: {
    _toast (toastText, time = 3000) {
      this.toastText = toastText
      this.showToast = true
      setTimeout(() => {
        this.showToast = false
      }, time)
    },
    async createInit() {
      if (this.$route.params.code) this.$store.commit('setSymbol', this.$route.params)
      else this.$store.commit('setSymbol', this.$route.query)
      let stockname = await this.getStockName()
      this.$store.commit('setStockName', stockname)
    },
    /**
     * 获取个股名称
     */
    async getStockName () {
      function marketTransform(val) {
        let keytmar = {
          NASDAQ: 'NASDAQ',
          nasdaq: 'NASDAQ',
          NA: 'NASDAQ',
          sh: 'sh',
          SH: 'sh',
          sz: 'sz',
          SZ: 'sz',
          HK: 'HKSE',
          hk: 'HKSE',
          hkse: 'HKSE',
          AMEX: 'AMEX',
          amex: 'amex',
          AM: 'AMEX',
          am: 'AMEX',
          HKIDX: 'HKIDX',
          hkidx: 'HKIDX'
        }
        return keytmar[val] || val
      }
      console.log(this.$store.state.market)
      let market = marketTransform(this.$store.state.market)
      let symbol = this.$store.state.code
      if (this.$store.state.isIndex && this.$store.state.region === 'CN') market = market.toLowerCase()
      if (this.$store.state.region === 'HK') {
        symbol = symbol.length === 4 && /\d+/.test(symbol) ? '0' + symbol : symbol
      }
      if (symbol.toUpperCase() === 'BRKA' || symbol.toUpperCase() === 'BRKB') {
        symbol = 'BRK' + symbol.slice(-1).toLowerCase()
      }
      let res = await request.get({
        url: request.apis.quote.getStockName,
        params: {
          symbol,
          market,
          keyword: this.$store.state.code,
        }
      })
      
      if (res && res.length > 0) {
        return res[0].Name
      }
    },
    async sendView() {
      if (!this.title || !this.content) return
      const { code, market, content, title, userInfo } = this
      const params = {
        token: userInfo.token,
        serverId: userInfo.serverId,
        recommendation: 0,
        applicationCode: '9fztgw',
        creatorType: 0,
        contentType: 0,
        symbol: code.toString().toLowerCase(),
        market: market.toLowerCase(),
        content,
        title,
        areas: [0],
        columnCodes: ['stock.bar']
      }
      let res = await request.post({
        url: request.apis.stockBar.publish,
        params
      })
      if (res) {
        this._toast('帖子已提交，将在审核完毕后发布')
        this.title = ''
        this.content = ''
        this.tabs[this.tabIndex].list = []
        this.tabs[this.tabIndex].pageNo = 1
        setTimeout(() => {
          this.$router.back()
        }, 2000)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
div
  box-sizing border-box
.red-color
  color #f43737
.user-info-box
  display flex
  align-items center
  padding-bottom 12px
  margin-bottom 4px
  color #666666
  border-bottom 1px solid #F5F5F5
  img
    width 30px
    height 30px
    border-radius 50%
    margin-right 8px

.send-warp
  display flex
  flex-direction column
  // height 100vh
  padding 55px 12px 105px 12px
  font-size 15px
  background #fff
  .input-box
    height 45px
    display flex
    justify-content space-between
    align-items center
    color #333
    border-bottom 1px solid #F5F5F5
    input
      height 44px
      flex 1
      border none
      font-size 18px
      outline none
  .content-box
    flex 1
    textarea
      width 100%
      height 100%
      min-height 300px
      outline none
      font-size 15px
      padding 12px 0
      border: none
.send-footer
  height 105px
  position fixed
  left 0
  bottom 0
  // width 100%
  padding 10px 16px
  color #999
  border-top 1px solid #dcdcdc
  p
    height 38px
    margin-bottom 10px
.send-btn
  display flex
  height 36px
  justify-content center
  background #F43737
  border-radius 2px
  align-items center
  color #fff
  &.disable
    background #BDBDBD
.icon-send
  width 16px
  height 14px
  margin-left 2px
  background url('~@/assets/icon-send.png')
  background-size: 100% 100%
  align-items center
</style>